<template>
  <div class="zcontainer" v-if="gallery">
    <div class="sub-header">
      <div class="columns sub-header-columns">
        <div class="column">
          <div class="flex">
            <router-link to="/">
              <img src="../assets/findupix-logo-svg.svg" class="brand" />
            </router-link>
            <h1 class="title">{{ gallery.name }}</h1>
          </div>
        </div>
      </div>
      <div class="stats">
        <span class="tag is-primary"> {{ uploaded }} fotos subidas</span>
      </div>
    </div>

    <section id="gallery" v-if="gallery" class="container">
      <file-upload
        v-if="userProfile.role === 'admin'"
        class="has-margin-bottom-2"
        v-bind:accept="'image/*'"
        v-bind:prefix="'galleries'"
        v-bind:gallery-id="gallery.id"
        v-bind:gallery="gallery"
        v-bind:multiple="true"
        @uploaded="onUploaded"
      ></file-upload>

      <div class="notification is-warning" v-if="userProfile.role !== 'admin'">
        Atención, su usuario tiene acceso acceso limitado, no podrá crear ni
        editar galerias.
      </div>
    </section>
  </div>
</template>

<script>
import FileUpload from "@/components/FileUpload.vue";
import { mapState } from "vuex";
const fb = require("../firebase");
import axios from "axios";
import { EventBus } from "../services/event-bus.js";
import { debounce } from "debounce";

export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      gallery: {},
      // galleriesArray: [],
      uploaded: 0,
    };
  },
  computed: {
    ...mapState(["userProfile", "galleries"]),
  },
  mounted() {
    if (this.$route.params.id) {
      this.galleryId = this.$route.params.id;
      this.viewGallery();

      EventBus.$on("file-uploaded", (fileInfo) => {
        //this.reloadImageView();
        // this.tableView = true
      });
    }
  },
  methods: {
    viewGallery() {
      fb.galleriesCollection
        .doc(this.galleryId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.gallery = doc.data();
            this.gallery.id = this.galleryId;
            this.galleryName = this.gallery.name;
            this.subscribeToChanges();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onUploaded(info) {
      //console.log("onUploaded info", info);
    },
    subscribeToChanges() {
      EventBus.$on("file-uploaded", (fileInfo) => {
        //this.reloadImageView();
        this.uploaded++;
      });
    },
  },
};
</script>
<style scoped>
.brand {
  width: calc(100px + 0.5rem);
  margin-left: -0.5rem;
  margin-top: 4px;
}
.title {
  margin-top: 1.1rem;
  margin-left: 1rem;
}
.card-image {
  max-height: 200px;
  width: 100%;
}
.card {
  font-size: 0.85rem;
  border: 2px solid transparent;
  position: relative;
}
.card-text {
  padding: 0.5rem;
}
.gallery {
  margin-top: 1rem;
}
.card:hover {
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.2);
}
.buttons {
  margin-top: 1.5rem;
  text-align: right;
}
.buttons i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}
.card-selected {
  border: 2px solid #3298dc;
}
.input {
  border: 0;
  border-radius: 0;
  border-bottom: 2px solid hsl(0, 0%, 71%);
  outline: none;
  font-size: 1.5rem;
}
.input:focus,
.input:active {
  border-bottom: 2px solid hsl(171, 100%, 41%);
  outline: none;
  box-shadow: none;
}
.stats {
  color: #6c757d;
  margin-bottom: 1rem;
}
.stats .tag {
  margin-right: 0.5rem;
  cursor: pointer;
  font-size: 0.9rem;
}
.stats .tag.tag-selected {
  font-weight: bold;
}
.tag-circle {
  border-radius: 50%;
  width: 26px;
  height: 26px;
  opacity: 0.9;
}
.tag-circle i {
  font-size: 16px;
}
</style>
<style>
.v-data-table-header th.sortable {
  padding-top: 12px !important;
}
.v-data-table table tbody tr td {
  padding-top: 14px !important;
  color: #6c757d !important;
  cursor: pointer;
  font-size: 0.85rem !important;
}
.row-v-data-table {
  padding-bottom: 2rem !important;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding-top: 8px !important;
}
.sub-header {
  position: fixed;
  width: 100%;
  top: 0px;
  border-bottom: 2px solid #eee;
  z-index: 10;
  background-color: #fff;
  left: 0;
  padding: 0 1.5rem;
}
#gallery {
  margin-top: 160px;
}
.pager {
  font-size: 30px;
}
.pager.disabled {
  color: #ccc;
}
.flex {
  display: flex;
}
.search-input {
  display: inline-block;
  width: 150px;
  box-shadow: none;
  font-size: 0.8rem !important;
  padding: 0 4px;
}
</style>